import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

const bootstrap = () => bootstrapApplication(App, appConfig).catch((err) => console.error(err));

if ((environment as any).runtime) {
  fetch('/assets/config.json')
    .then((response) => response.json())
    .then((config) => {
      Object.assign(environment, config);
    })
    .catch(() => {
      console.warn('Config file not loaded, using default environment');
    })
    .finally(bootstrap);
} else {
  bootstrap();
}
